import { Component, OnInit } from "@angular/core";
import { BaseComponent } from "../../base-component/base.component";

@Component({
	selector: 'app-league-team-members',
	templateUrl: './league-team-members.component.html'
})
export class LeagueTeamMemberComponent extends BaseComponent implements OnInit {
	ngOnInit(): void {
	}
}